import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useFpB2bPaymentService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-payment-service'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiGetFpPayment } from '@hooks-api/fortune/useApiGetFpPayment'
import { PaymentMethodType, PaymentServiceType } from '@hooks-api/types/dataModel/payment'
import { TappayJkoPayModule } from '@payments'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { JkoPay } from '@pets-ui/icons'
import { Radio } from '@pets-ui/Radio/Radio'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom-v5'
import { useContextPayment } from '../../../../fp-b2b-shared/components/PaymentProvider/PaymentProvider'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { paymentComponentStyle } from './PaymentMethodComponent'

export const PaymentTappayJkoPay = () => {
  const { selectedPayment, setSelectedPayment, paymentMethods, setPaymentExecution, getActivePaymentModuleB2B, setConfiguredPaymentModule, isSdkInitialized, setIsLoadingPayment } = useContextPayment()
  const { trigger: getPaymentToken } = useApiGetFpPayment()
  const { env, campaignId, campaignCode, platform } = useCheckout()
  const { calculateResult: campaignCouponCalculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const { total } = campaignCouponCalculateResult || {}

  const checked = selectedPayment?.service_type === PaymentServiceType.TAPPAY && selectedPayment.type === PaymentMethodType.JKO_PAY
  const currentMethod = paymentMethods.find(method => method.service_type === PaymentServiceType.TAPPAY && method.type === PaymentMethodType.JKO_PAY)
  const paymentModule = getActivePaymentModuleB2B(PaymentServiceType.TAPPAY, PaymentMethodType.JKO_PAY)

  const { transactionId: paymentTransactionIdFromUrl } = useParams<{ transactionId?: string }>()
  const { orderId, orderType } = useFpB2bPaymentService({ campaignId, paymentTransactionIdFromUrl, campaignCode, platform })

  const handleSelectPayment = useCallbackEvent(async () => {
    try {
      if (!campaignCode) {
        throw new Error('Missing campaign code')
      }
      if (!total) {
        throw new Error('Missing total')
      }
      if (!currentMethod) {
        throw new Error('Missing payment method')
      }

      setSelectedPayment(currentMethod)

      setIsLoadingPayment(true)
      const token = await getPaymentToken({
        order_type: orderType,
        order_id: orderId,
        payment_method_id: currentMethod.id,
      })

      const { app_id, app_key } = token.data.data.payment_service_provider_info
      if (!paymentModule || !(paymentModule instanceof TappayJkoPayModule)) {
        throw new Error('Wrong paymentModule')
      }
      if (!app_id || !app_key) {
        throw new Error('Wrong app_id, app_key')
      }
      paymentModule.configurePayment({
        appId: String(app_id),
        appEnv: env,
        appKey: app_key,
      })
      const { payment_transaction_id } = token.data.data
      setPaymentExecution({
        payment_transaction_id,
        service_pay_info: null,
        user_payment_token_info: undefined,
        payment_success_url: '',
        payment_fallback_url: '',
      })
      setConfiguredPaymentModule(paymentModule)
    }
    catch (error) {
      console.error(`[PaymentJkoPay] ${error}`)
    }
    finally {
      setIsLoadingPayment(false)
    }
  })
  // NOTE: init for default payment
  useEffect(() => {
    // NOTE: isSdkInitialized promises that the payment paymentModule is init after sdk init
    const shouldInit = selectedPayment?.service_type === PaymentServiceType.TAPPAY && selectedPayment.type === PaymentMethodType.JKO_PAY && isSdkInitialized
    if (!shouldInit) return
    handleSelectPayment()
  }, [handleSelectPayment, isSdkInitialized, selectedPayment?.service_type, selectedPayment?.type])

  return (
    <Box component="label" rootStyle={[paymentComponentStyle.root, paymentComponentStyle.radioPaymentChecked]}>
      <VStack flexGrow={1} gap={2.5}>
        <HStack alignItems="center" gap={2}>
          <Radio
            name="paymentJko"
            checked={checked}
            value="paymentJko"
            onChange={handleSelectPayment}
          />
          <JkoPay />
          <Text fontWeight={600} lineHeight="100%">街口支付</Text>
          <Box flexGrow={1} />
          {/* endIcon */}
        </HStack>
      </VStack>
    </Box>
  )
}
